import React, { useState } from 'react';
import { useAppStateContext } from 'src/AppState/AppState';
import { observer } from 'src/utils/mobx-react';
import { ForecastTricastState } from 'src/components/CustomersBar/EventsTab/RacingTab/QuickPickView/ForecastTricast/ForecastTricast.state';
import { QuickPickViewState, sortSelections } from 'src/components/CustomersBar/EventsTab/RacingTab/QuickPickView/QuickPickView.state';
import { RaceWinnerColumn } from 'src/components/CustomersBar/EventsTab/RacingTab/QuickPickView/RaceWinner/RaceWinnerColumn';
import { FixedPlaceColumn } from 'src/components/CustomersBar/EventsTab/RacingTab/QuickPickView/ForecastTricast/FixedPlaceColumn';

interface ForecastTricastTypeProps {
    quickPickState: QuickPickViewState;
    userId: number;
}

export const ForecastTricast = observer('ForecastTricast', (props: ForecastTricastTypeProps) => {
    const appState = useAppStateContext();
    const [state] = useState(() => new ForecastTricastState(appState, props.userId));
    const event = props.quickPickState.getSelectedEvent;

    if (event === null) {
        return null;
    }

    const market = event.marketRaceWinner[0];

    if (market === undefined) {
        return null;
    }

    const columns = [];

    if (market.tricastsOffered) {
        columns.push(
            {
                places: 3,
                key: 'tricast',
                title: 'Tricast',
                state: state.tricast
            }
        );
    }

    if (market.forecastsOffered) {
        columns.push(
            {
                places: 2,
                key: 'forecast',
                title: 'Forecast',
                state: state.forecast
            }
        );
    }

    const selections = sortSelections(market.selections, props.quickPickState.sort);

    return (
        <div className='forecast-tricast-table'>
            <RaceWinnerColumn
                userId={props.userId}
                eventId={event.id}
                marketId={market.id}
                quickPickState={props.quickPickState}
            />
            { columns.map(column => (
                <FixedPlaceColumn
                    key={column.key}
                    title={column.title}
                    places={column.places}
                    event={event}
                    market={market}
                    forecastTricastState={state}
                    selections={selections}
                />
            )) }
        </div>
    );
});


